'use client'

import React from 'react'
import type { Header } from '@/payload-types'
import { HeaderNav } from './Nav'
import { PillCap } from '@/components/ui/PillCap'

interface HeaderActionsProps {
  data: Header
  mobile?: boolean
  onMenuItemHover?: (index: number | null, immediate?: boolean) => void
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({
  data,
  mobile = false,
  onMenuItemHover,
}) => {
  const containerClass = mobile ? 'd-flex flex-column gap-3' : 'd-none d-xl-flex align-items-center'

  const buttonClass = mobile ? 'btn btn-pill w-100' : 'btn btn-pill ms-4'

  return (
    <div className={containerClass}>
      <HeaderNav data={data} mobile={mobile} onMenuItemHover={onMenuItemHover} />

      {data.ctaButtonSuccess?.text && data.ctaButtonSuccess?.url && (
        <a className={`${buttonClass} btn-pill-glow`} href={data.ctaButtonSuccess.url}>
          {data.ctaButtonSuccess.text}
          <PillCap />
        </a>
      )}

      {data.ctaButtonDanger?.text && data.ctaButtonDanger?.url && (
        <a className={`${buttonClass} btn-pill-outline`} href={data.ctaButtonDanger.url}>
          {data.ctaButtonDanger.text}
          <PillCap />
        </a>
      )}

      {data.ctaButtonPrimary?.text && data.ctaButtonPrimary?.url && (
        <a className={`${buttonClass} btn-pill-primary`} href={data.ctaButtonPrimary.url}>
          {data.ctaButtonPrimary.text}
          <PillCap />
        </a>
      )}
    </div>
  )
}
